import { render } from "./DeviceDetail.vue?vue&type=template&id=be103e58"
import script from "./DeviceDetail.vue?vue&type=script&lang=js"
export * from "./DeviceDetail.vue?vue&type=script&lang=js"
script.render = render

export default script